import { ref } from 'vue';

export const currentModal = ref(null);
export const resetPasswordParams = ref(null);
export const signUpRole = ref('both'); // Default role for signup

export function openLoginModal() {
  currentModal.value = 'login';
}

export function openSignUpModal(role = 'both') {
  signUpRole.value = role;
  currentModal.value = 'signup';
}

export function openResetPasswordModal(params = null) {
  resetPasswordParams.value = params;
  currentModal.value = 'resetPassword';
}

export function closeModal() {
  currentModal.value = null;
}
